import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'

interface ImageZoomModalProps {
	open: boolean
	onOpenChange: (open: boolean) => void
}

export default function ImageZoomModal({
	open,
	onOpenChange,
}: ImageZoomModalProps) {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-2xl">
				<DialogHeader>
					<DialogTitle>ตัวอย่างข้อความ Flex Message</DialogTitle>
				</DialogHeader>
				<div className="flex justify-center">
					<img
						src="/src/images/promotion.png"
						alt="ตัวอย่างข้อความ Flex Message"
						className="h-auto w-full max-w-md rounded-lg border shadow-lg"
					/>
				</div>
			</DialogContent>
		</Dialog>
	)
}
